"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BoxedModal = function BoxedModal(props) {
  var classes = (0, _classnames["default"])("boxedModal-component", props.className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "boxModalContentContainer"
  }, props.children));
};
BoxedModal.propTypes = {
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
BoxedModal.defaultProps = {
  className: "",
  style: {}
};
var _default = exports["default"] = BoxedModal;